import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const MARQUEE_ITEMS = ["REACT", ".NET", "DEVOPS", "CLAUDE AI", "POSTGRESQL", "GITHUB ACTIONS", "JAVA", "SQL", "IIS"];

const keyify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");

export const SkillsSection = ({ t }) => {
  return (
    <div className="font-mono relative">
      <div className="absolute -top-4 left-0 right-0 opacity-50 pointer-events-none select-none overflow-hidden">
        <Marquee speed={40} gradient={false} autoFill>
          {MARQUEE_ITEMS.map((item) => (
            <span
              key={item}
              className="text-6xl md:text-7xl font-bold tracking-tighter mx-8 text-transparent"
              style={{ WebkitTextStroke: "1px var(--stroke)" }}
            >
              {item}
            </span>
          ))}
        </Marquee>
      </div>

      <div className="relative pt-24">
        <h2 className="text-2xl sm:text-3xl font-bold text-[var(--text)] mb-2">
          <span className="text-[var(--kw)]">module</span>
          <span className="text-[var(--muted)]">.</span>
          <span className="text-[var(--var)]">exports</span>
          <span className="text-[var(--muted)]"> = {"{"}</span>
        </h2>
        <p className="text-[11px] text-[var(--cm)] mb-10">{"// "}{t.skills.heading} — {t.skills.overline.toLowerCase()}</p>

        <div className="space-y-6 pl-2 sm:pl-6">
          {t.skills.groups.map((group, gi) => (
            <motion.div
              key={gi}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: gi * 0.06 }}
              data-testid={`skills-group-${gi}`}
              className="hover:bg-[var(--line-hover)] transition-colors py-2 -mx-2 px-2"
            >
              <span className="text-[var(--var)] text-sm">{keyify(group.title)}</span>
              <span className="text-[var(--muted)]">: [</span>
              <span className="inline-flex flex-wrap gap-2 align-middle ml-1">
                {group.items.map((skill) => (
                  <span
                    key={skill}
                    className="text-[11px] px-2.5 py-1 border border-[var(--border)] text-[var(--str)] hover:border-[#FF5722]/50 hover:-translate-y-0.5 transition-[border-color,transform] duration-200"
                  >
                    "{skill}"
                  </span>
                ))}
              </span>
              <span className="text-[var(--muted)]">],</span>
            </motion.div>
          ))}

          <div data-testid="skills-soft" className="py-2">
            <span className="text-[var(--var)] text-sm">{keyify(t.skills.soft.title)}</span>
            <span className="text-[var(--muted)]">: [</span>
            <span className="inline-flex flex-wrap gap-2 align-middle ml-1">
              {t.skills.soft.items.map((item) => (
                <span key={item} className="text-[11px] px-2.5 py-1 border border-[var(--border)] text-[var(--fn)]">
                  "{item}"
                </span>
              ))}
            </span>
            <span className="text-[var(--muted)]">]</span>
          </div>
        </div>

        <div className="text-2xl text-[var(--muted)] mt-6">{"};"}</div>
      </div>
    </div>
  );
};
